import {
  DialogProps,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  useTheme,
} from '@mui/material'
import { AnimatedCheckmark } from './checkmark'
import { AnimatedXMark } from './xmark'

type FeedbackDialogProps = DialogProps & {
  type: 'success' | 'error'
  title: string
  closeLabel?: string
  confirmLabel?: string
  onConfirm?: () => void
  onClose?: () => void
  children: React.ReactNode
}

export const FeedbackDialog = ({
  children,
  title,
  closeLabel,
  confirmLabel,
  onConfirm,
  onClose,
  type,
  ...props
}: FeedbackDialogProps) => {
  const theme = useTheme()

  return (
    <Dialog {...props}>
      <DialogTitle sx={{ textAlign: 'center' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', m: 4 }}>
          {type === 'success' && (
            <AnimatedCheckmark color={theme.palette.success.main} />
          )}
          {type === 'error' && (
            <AnimatedXMark color={theme.palette.error.main} />
          )}
        </Box>
        {title}
      </DialogTitle>

      <DialogContent>{children}</DialogContent>

      <DialogActions>
        {onClose && (
          <Button onClick={onClose} variant="text">
            {closeLabel}
          </Button>
        )}
        {onConfirm && <Button onClick={onConfirm}>{confirmLabel}</Button>}
      </DialogActions>
    </Dialog>
  )
}
